import React, { FC } from "react";

import MainLayout from "src/components/Layout/MainLayout";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  page: {
    textAlign: "center",
  },
}));

export type PageProps = {
  seoHead: any;
  header?: any;
  content: any;
  dataTestId: string;
};

const Page: FC<PageProps> = (props) => {
  const { seoHead, header, content, dataTestId } = props;
  const classes = useStyles();

  return (
    <MainLayout>
      {seoHead}
      <div className={classes.page} data-test={dataTestId}>
        {header && header}
        {content}
      </div>
    </MainLayout>
  );
};

export default Page;
